import * as React from 'react';

const ImageUploadErrors = ({ uploadErrors, showErrors }) => (
  <div
    className={`error-container ${!showErrors ? 'hide-error-container' : 'show-error-container'}`}
  >
    <table className="cr-text-s">
      <thead>
        <tr>
          <th>File Skipped</th>
          <th>Reason</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(uploadErrors).map((error, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={index}>
            <td className="notranslate">{error}</td>
            <td>{uploadErrors[error]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ImageUploadErrors;
